import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';

import Loading from '@/components/common/Loading';
import { useTranslate } from '@/hooks/useTranslate';
import { getVideoList } from '@/services/assets';

import { Item, VideoItem } from './VideoItem';

export const VideoLibList = forwardRef<
  {
    getSelectedItems: () => Array<Item>;
  },
  { type?: number }
>((props, ref) => {
  {
    const { type = 3 } = props;
    const staticParams = {
      pageSize: 50,
      sourceType: 1,
      type,
    };

    const { t } = useTranslate();
    const [videoList, setVideoList] = useState<any>([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [total, setTotal] = useState(0);
    const selectedItems = useRef<Array<Item>>([]);

    useImperativeHandle(ref, () => ({
      getSelectedItems: () => selectedItems.current,
    }));
    const getList = (page: number) => {
      setLoading(true);
      getVideoList({
        pageNum: page,
        ...staticParams,
      })
        .then((res: any) => {
          setLoading(false);
          if (res.code === 200) {
            const { totalCount, items } = res;
            setTotal(totalCount);
            if (items && Array.isArray(items) && items.length > 0) {
              const list = page === 1 ? items : [...videoList, ...items];
              setVideoList(list);
              setCurrentPage(page);
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };
    useEffect(() => {
      getList(1);
    }, []);

    useEffect(() => {
      // 监听滚动
      const fixedParent = document.querySelector('.relative-parent');
      const observerDomParent = document.querySelector('.observer-parent');
      const observerDom = document.querySelector('.observer-dom');

      if (!fixedParent || !observerDomParent || !observerDom) return;
      if (observerDomParent.scrollHeight < fixedParent.clientHeight) return;
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (videoList.length >= total) return;
            getList(currentPage + 1);
          }
        });
      });
      observer.observe(observerDom);
      return () => observer.disconnect();
    }, [currentPage, videoList, total]);
    return (
      <div className="h-[348px] bg-color-bg-0-2 p-[10px] rounded-[6px] flex flex-col gap-y-[14px]">
        <div className="h-[30px] text-[12px] font-[600] leading-[16px] text-[#000] pl-[53px] pr-[20px] flex flex-row items-center justify-between">
          <span>{t('bc.sc.title')}</span>
          <div className="w-[130px] pl-[20px]">
            <span>{t('bc-upload-date')}</span>
          </div>
        </div>
        <div className="flex-1 overflow-hidden relative">
          {loading && <Loading />}
          {videoList?.length > 0 ? (
            <div className="relative-parent h-[100%] px-[10px] overflow-y-scroll">
              <div className="observer-parent flex flex-col gap-[16px]">
                {videoList.map((item: Item) => {
                  return (
                    <VideoItem
                      key={item.id}
                      item={item}
                      onSelect={(item, status) => {
                        if (status) {
                          selectedItems.current.push(item);
                        } else {
                          selectedItems.current = selectedItems.current.filter(
                            (sitem) => sitem.id !== item.id,
                          );
                        }
                      }}
                    />
                  );
                })}
                <div className="observer-dom h-[10px]"></div>
              </div>
            </div>
          ) : (
            <div className="h-full flex items-center justify-center">
              {t('Oops-nothing-here')}
            </div>
          )}
        </div>
      </div>
    );
  }
});
